module.exports = __webpack_public_path__ + "static/9-9aa77970ecf0e286a36442ff159faa59.jpg";